import { Component, OnInit } from '@angular/core';
import { BroadcastService } from '@services/broadcast-service';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from '../app.config';

@Component({
  selector: 'app-outgoing-call-feedback',
  templateUrl: './outgoing-call-feedback.html',
  standalone: false,
})
export class OutgoingCallFeedbackComponent implements OnInit {
  loading: boolean = false;
  user: any;
  callLogId: string = '';
  selectedRating: number | null = null;
  comment: string = '';
  ratingArray: Array<string> = [
    'nps-rate-bad',
    'nps-rate-bad',
    'nps-rate-bad',
    'nps-rate-bad',
    'nps-rate-bad',
    'nps-rate-bad',
    'nps-rate-bad',
    'nps-rate-avg',
    'nps-rate-avg',
    'nps-rate-good',
    'nps-rate-good',
  ];

  constructor(
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private broadcast: BroadcastService,
    private conn: ConnectionService,
    private eventLogger: EventLoggerService,
  ) {}

  ngOnInit(): void {
    this.user = this.conn.getActingUser();
    this.callLogId = this.activatedRoute.snapshot.queryParams['callLogId'] || '';
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'OutgoingCallFeedbackPage' }));
    this.eventLogger.trackEvent('outgoing_call_feedback_page_opened');
  }

  selectRating(rating: number): void {
    this.selectedRating = rating;
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: 'outgoing_call_feedback_rating_selected',
      score: rating,
    }));
    this.eventLogger.trackEvent('outgoing_call_feedback_rating_selected', { score: rating });
  }

  isSelected(i: number): boolean {
    return this.selectedRating === i;
  }

  getRatingBgColor(i: number): string {
    if (this.selectedRating !== i) return '';
    if (i >= 9) return '#d1fae5';
    if (i >= 7) return '#fef9c3';
    return '#fee2e2';
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  async submitOutgoingCallFeedback(): Promise<void> {
    if (this.selectedRating === null) {
      this.broadcast.broadcast('NOTIFY', { message: 'Please select a rating' });
      return;
    }
    try {
      this.loading = true;
      const requestBody: { score: number; callLogId?: string; feedback?: string } = {
        score: this.selectedRating,
      };
      if (this.callLogId) {
        requestBody.callLogId = this.callLogId;
      }
      if (this.comment.trim()) {
        requestBody.feedback = this.comment.trim();
      }
      await this.conn.createOutgoingCallFeedback(requestBody);
      this.loading = false;
      this.eventLogger.trackEvent('outgoing_call_feedback_submitted', {
        score: this.selectedRating,
        hasComment: !!this.comment.trim(),
      });
      this.broadcast.broadcast('NOTIFY', { message: 'Thanks for your valuable feedback' });
      this.back();
    } catch (error) {
      this.loading = false;
      this.broadcast.broadcast('NOTIFY', { error });
    }
  }
}
